export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9651.2f6d9545.jpg";